<template>
	<page title="Active Projects">
		<template #actions>
			<create-project v-if="auth.user_type === 1 || auth.user_type === 2" />
			<create-client v-if="auth.user_type === 1" />
			<create-user v-if="auth.user_type === 1" />
		</template>

		<projects-table title="Active Projects" :projects="projects" />
		<v-btn
			elevation="5"
			color="warning"
			dark
			fixed
			bottom
			right
			class="floating-top-btn justify-start"
			@click="toTop">
			<v-icon left class="pr-3 pl-1">mdi-arrow-up-bold</v-icon>
			Back to top
		</v-btn>
	</page>
</template>
<script>
import Backend from '@/Layouts/Backend'
import Page from '@/Pages/Backend/Components/Page'
import ProjectsTable from '@/Pages/Backend/Projects/Table'
import CreateProject from '@/Pages/Backend/Projects/Create'
import CreateClient from '@/Pages/Backend/Clients/Create'
import CreateUser from '@/Pages/Backend/Users/Create'

export default {
	components: { Page, ProjectsTable, CreateProject, CreateClient, CreateUser },
	layout: Backend,
	props: {
		projects: {
			type: [Array, Object],
			default: () => {},
			required: true
		}
	},
	data () {
		return {
			auth: this.$page.props.auth
		}
	},
	methods: {
		toTop () {
			window.scrollTo({ top: 0, behavior: 'smooth' })
		}
	}
}
</script>
